<template>
  <div class="flex-1 flex flex-col overflow-hidden">
    <!-- Header -->
    <div class="flex-shrink-0 flex items-center justify-between px-6 py-3.5 border-b border-gray-100 dark:border-gray-700">
      <h2 class="text-base font-semibold text-gray-900 dark:text-white truncate">
        Search results for <span class="font-normal text-gray-500 dark:text-gray-400">&quot;{{ query }}&quot;</span>
      </h2>
      <button
        @click="emit('close')"
        class="w-9 h-9 flex-shrink-0 flex items-center justify-center rounded-full hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
        aria-label="Close search results"
        title="Close search results"
      >
        <svg class="w-5 h-5 text-gray-600 dark:text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
        </svg>
      </button>
    </div>

    <!-- Body -->
    <div class="flex-1 overflow-y-auto divide-y divide-gray-50 dark:divide-gray-800/60">
      <!-- Loading skeleton -->
      <div v-if="loading" class="animate-pulse divide-y divide-gray-100 dark:divide-gray-800">
        <div v-for="n in 6" :key="n" class="flex items-center gap-3 px-6 py-3.5">
          <div class="w-5 h-5 rounded bg-gray-200 dark:bg-gray-700 flex-shrink-0"></div>
          <div class="flex-1 h-3 bg-gray-100 dark:bg-gray-800 rounded"></div>
          <div class="w-16 h-3 bg-gray-200 dark:bg-gray-700 rounded flex-shrink-0"></div>
        </div>
      </div>

      <!-- Empty state -->
      <div v-else-if="results.length === 0" class="flex flex-col items-center justify-center py-32 text-center px-4">
        <div class="w-16 h-16 rounded-full bg-gray-100 dark:bg-gray-800 flex items-center justify-center mb-4">
          <svg class="w-7 h-7 text-gray-400 dark:text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-4.35-4.35M11 19a8 8 0 100-16 8 8 0 000 16z"/>
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 9l3 3m0-3l-3 3"/>
          </svg>
        </div>
        <h3 class="text-base font-semibold text-gray-900 dark:text-white mb-1">No matching events</h3>
        <p class="text-sm text-gray-500 dark:text-gray-400">Try a different search term</p>
      </div>

      <!-- Chronological results -->
      <template v-else>
        <CalendarSearchResultRow
          v-for="result in results"
          :key="result.id"
          :result="result"
          @click="emit('select', result)"
        />
      </template>
    </div>
  </div>
</template>

<script setup>
import CalendarSearchResultRow from './CalendarSearchResultRow.vue'

defineProps({
  query:   { type: String, default: '' },
  results: { type: Array, default: () => [] },
  loading: { type: Boolean, default: false },
})

const emit = defineEmits(['close', 'select'])
</script>
